export default "__VITE_ASSET__4535b5e5__"